import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { Google } from '@mui/icons-material';

interface GoogleConnectProps {
  onConnect: () => void;
  loading: boolean;
}

function GoogleConnect({ onConnect, loading }: GoogleConnectProps) {
  const handleConnect = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '361172392341-ekgg60higmkbqdl4u8564v1chhcoc4n3.apps.googleusercontent.com';
    const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000/callback');
    const scope = encodeURIComponent('https://www.googleapis.com/auth/business.manage');
    const responseType = 'code';

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${responseType}&access_type=offline&prompt=consent`;

    console.log('OAuth URL:', authUrl);
    
    // Direct redirect to Google OAuth
    window.location.href = authUrl;
  };

  return (
    <Button
      variant="contained"
      size="large"
      startIcon={loading ? <CircularProgress size={20} /> : <Google />}
      onClick={handleConnect}
      disabled={loading}
      sx={{ px: 4, py: 1.5 }}
    >
      Connect Google Business Profile
    </Button>
  );
}

export default GoogleConnect;
